"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _q = _interopRequireDefault(require("q"));

function spread(promises, onFulfilled, onRejected) {
  return _q.default.Promise.all(promises).then(function (values) {
    return onFulfilled.apply(void 0, (0, _toConsumableArray2.default)(values));
  }, onRejected);
}

var _default = spread;
exports.default = _default;
module.exports = exports.default;